import React from 'react';

import { SimpleObject } from '@clearverify/types';

import { VerifierInfoFragment } from 'src/api';
import { Modal } from 'src/components/common';
import { VerifierVerifyManuallyByCVStaffModalForm } from 'src/components/verifier';
import { ModalId } from 'src/constants/modals';
import { useModal } from 'src/hooks/shared';

export interface VerifierVerifyManuallyByCVStaffModalArgs extends SimpleObject {
  verifier: VerifierInfoFragment;
}

export const VerifierVerifyManuallyByCVStaffModal: React.FC = () => {
  const { closeModal, switchClosability, isOpen, args } =
    useModal<VerifierVerifyManuallyByCVStaffModalArgs>(
      ModalId.VerifierVerifyManuallyByCVStaffModal,
    );

  const handleCloseModal = React.useCallback(() => {
    closeModal();
  }, [closeModal]);

  return (
    <Modal
      title="Manual Verification"
      dialogProps={{
        onClose: handleCloseModal,
        open: isOpen,
      }}
      headerPadding="32px 32px 0 32px"
      maxWidth={580}
    >
      <VerifierVerifyManuallyByCVStaffModalForm
        verifier={args?.verifier}
        onCloseModal={handleCloseModal}
        switchClosability={switchClosability}
      />
    </Modal>
  );
};
